export const admission_dates =`Summer Program - 2024
Program Overview
The Summer Program offers an accelerated course schedule for students who wish to complete credits or catch up on their studies during the summer.

General
View Dates & Notes
Date Label	Date
Advertisement Date	April 28, 2024
Online Application	April 28, 2024
Last Date to Deposit Fees	May 30, 2024
Commencement of Classes	June 05, 2024
Classes End	July 31, 2024
Notes:
Policy for Summer Programs in Main Campus and Sub-campuses will remain the same.
Dates of Summer Program may change subject to changes in academic Calendar Spring-2024.
Crash Program - 2024
Program Overview
The Crash Program is designed to provide intensive, focused study sessions for students, often condensed into a short timeframe to cover significant material quickly.

General
View Dates & Notes
Date Label	Date
Advertisement Date	April 07, 2024
Online Application	April 07, 2024
Last Date to Deposit Fees	May 09, 2024
Commencement of Classes	May 13, 2024
Classes End	June 10, 2024
Undergraduate Admissions - 2024
Program Overview
Undergraduate programs at Sukkur IBA University cover a range of disciplines, offering both foundational knowledge and industry-relevant skills to prepare students for the workforce.

Phase 1
View Dates & Notes
Date Label	Date
Advertisement Date	May 12, 2024
Online Application	May 12, 2024
Last Date to Apply and Deposit Fees	June 17, 2024
SIBAU UG Aptitude Test Date	June 23, 2024
Result Announcement	June 24, 2024
Notes:
Non-Engineering and Engineering Categories tests will be conducted as per their approved test pattern.
Phase 2
View Dates & Notes
MBA Admissions - 2024
Program Overview
The MBA program provides an advanced understanding of business principles, equipping graduates with leadership skills and expertise for careers in management and entrepreneurship.

Phase 1 (Non-Business and Business Category)
View Dates & Notes
Date Label	Date
Advertisement Date	April 07, 2024
Online Application	April 07, 2024
Last Date to Apply and Deposit Fees	May 06, 2024
SIBAU MBA GAT Test	May 12, 2024
Result Announcement	May 15, 2024
Interviews	May 22, 2024
Intensive Orientation Program	June 03, 2024 to July 31, 2024
Last Date of Registration	August 05, 2024
Commencement of Classes	August 12, 2024
Phase 2 (Business Category)
View Dates & Notes
PhD Admissions - 2025
Program Overview
PhD Admissions at Sukkur IBA are targeted towards aspiring researchers and professionals, focusing on in-depth research across various disciplines.

General
View Dates & Notes
Date Label	Date
Advertisement Date	July 28, 2024
Online Application	July 28, 2024
Last Date to Apply and Deposit Fees	August 29, 2024
SIBAU PhD GAT Test	September 08, 2024
Result Announcement	September 10, 2024
Interviews	September 18, 2024
Final Result Announcement	September 24, 2024
Last Date of Registration	October 14, 2024
Commencement of Classes	January 13, 2025
MS, ME, M.Phil Admissions - 2025
Program Overview
MS, ME, and M.Phil programs offer specialized knowledge in scientific, engineering, and management fields, fostering advanced research and professional skills.

General
View Dates & Notes
Date Label	Date
Advertisement Date	November 03, 2024
Online Application	November 03, 2024
Last Date to Apply and Deposit Fees	December 05, 2024
SIBAU GAT Test	December 15, 2024
Result Announcement	December 18, 2024
Interviews	December 26-27, 2024
Final Result Announcement	December 31, 2024
Last Date of Registration	January 09, 2025
Commencement of Classes	January 13, 2025
Regular Foundation Semester - 2024
Program Overview
The Regular Foundation Semester helps bridge gaps in knowledge and skills, preparing students for the rigorous academic environment of Sukkur IBA.

General
View Dates & Notes
Date Label	Date
Advertisement Date	August 18, 2024
Online Application	August 18, 2024
Last Date to Apply and Deposit Fees	September 16, 2024
SIBAU UG Aptitude Test Date	September 22, 2024
Commencement of Classes	October 01, 2024
Classes End	January 28, 2025
Final Examination	January 29-31, 2025
National Talent Hunt Program - 2024
Program Overview
The National Talent Hunt Program identifies and supports talented students from underprivileged backgrounds, providing them with educational opportunities and resources.

General
View Dates & Notes
Date Label	Date
Advertisement Date	October 06, 2024
Online Application	October 06, 2024
Last Date to Apply	November 07, 2024
SIBAU UG Aptitude Test Date	November 17, 2024
Commencement of Classes	February 03, 2025
Classes End	May 30, 2025
Final Examination	May 29-31, 2025
Sindh Talent Hunt Program - 2024
Program Overview
The Sindh Talent Hunt Program supports deserving students from Sindh by offering a pathway to education through scholarships and mentorship.

General
View Dates & Notes
Date Label	Date
Advertisement Date	December 01, 2024
Online Application	December 01, 2024
Last Date to Apply	January 02, 2025
SIBAU UG Aptitude Test Date	January 12, 2025
Commencement of Classes	February 03, 2025
Classes End	May 28, 2025
Final Examination	May 29-31, 2025`